import React from 'react'
import IconAction from '../IconAction'
import { useOnClickPromiseStates } from '../../../hooks'

const PromiseIconAction = props => {
  const state = useOnClickPromiseStates(props)
  return <IconAction {...props} {...state} />
}

export default PromiseIconAction
